import { useNetworkStatus } from '@games-monorepo/shared-hooks';
import './ConnectivityBanner.css';

export function ConnectivityBanner() {
	const isOnline = useNetworkStatus();

	if (isOnline) {
		return null;
	}

	return (
		<div className="connectivity-banner">
			<span>⚠️</span>
			<span>No Internet Connection</span>
		</div>
	);
}
